import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';

import { SkeletonProvider } from '@shared/v2/components/Skeleton';

import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import useCtaButtonStatus from '@/v2/components/pages/PackageView/hooks/useCtaButtonStatus';
import StickyFooter from '@/v2/components/ui/StickyFooter';
import { UI } from '@/v2/types';
import {
  AlternativeOfferButton,
  FooterCta,
  FooterSelectedRoom,
  MobileSearchPanel,
  UpgradeButton,
} from './components';

const ButtonSection = styled(Flex)`
  > * {
    flex: 1 1 100%;
  }
`;

const MobileFooter = ({ campaign }: { campaign: UI.Campaign | null }) => {
  const buttonStatus = useCtaButtonStatus();
  const { selectedRoomOption, selectedPackageOption, isLoading } =
    useRoomOptionsData() || {};
  const { isReady } = useRouter();
  const isReserveState = buttonStatus === 'reserve';

  return (
    <SkeletonProvider isLoading={isLoading || !isReady}>
      <StickyFooter
        display={['flex', null, 'none']}
        justifyContent="space-between"
        alignItems="flex-start"
        gap="2"
        bg="white"
        px="3"
        py="4"
      >
        <FooterSelectedRoom
          selectedRoomOption={selectedRoomOption}
          selectedPackageOption={selectedPackageOption}
        />
        <ButtonSection
          gap={isReserveState ? '4' : '2'}
          flexDirection={isReserveState ? 'column' : 'row'}
          maxWidth={selectedRoomOption?.matchingOffer ? '170px' : '100%'}
        >
          {!isReserveState && <AlternativeOfferButton />}
          <FooterCta />
          <UpgradeButton />
        </ButtonSection>
      </StickyFooter>
      <MobileSearchPanel campaign={campaign} />
    </SkeletonProvider>
  );
};

export default MobileFooter;
